import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { flowRight } from 'lodash'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { AppRootContext } from 'components/App'
import { isAdmin, isLoggedIn } from 'lib/utils/store/currentUser'
import { useTranslation } from 'react-i18next'
import useCurrentUser from 'lib/hooks/useCurrentUser'

import AppContext from 'components/AppContext'
import AppHeaderInboxLogic from './AppHeaderInboxLogic'
import AppHeaderDesktop from './AppHeaderDesktop/AppHeaderDesktop'
import AppHeaderMobile from './AppHeaderMobile/AppHeaderMobile'

import './app-header.pcss'

export const AppHeaderContext = React.createContext()

const AppHeader = ({ currentUserLoading }) => {
    const { breakpoints } = useContext(AppRootContext)
    const currentUser = useCurrentUser()
    const loggedIn = isLoggedIn(currentUser)

    useTranslation(['common', 'vehicles'])

    return (
        <AppHeaderInboxLogic loggedIn={loggedIn}>
            {({ unreadMessageCount }) => (
                <AppHeaderContext.Provider
                    value={{
                        loggedIn,
                        currentUserLoading,
                        unreadMessageCount,
                        currentUser,
                        isAdmin: isAdmin(currentUser),
                    }}
                >
                    {breakpoints.up('containerM') ? (
                        <AppContext context="headerDesktop">
                            <AppHeaderDesktop className="app-header" />
                        </AppContext>
                    ) : (
                        <AppContext context="headerMobile">
                            <AppHeaderMobile className="app-header" />
                        </AppContext>
                    )}
                </AppHeaderContext.Provider>
            )}
        </AppHeaderInboxLogic>
    )
}

AppHeader.propTypes = {
    currentUserLoading: PropTypes.bool.isRequired,
}

export default flowRight(
    withErrorBoundaryNoRender,
)(AppHeader)
